import type { RouteRecordRaw } from 'vue-router'
import DevLayout from '@/dev/DevLayout.vue'
import Test1View from '@/dev/Test1View.vue'
import Test2View from '@/dev/Test2View.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/:lang(th|en)/dev',
    component: DevLayout,
    children: [
      { path: '1', component: Test1View, meta: { next: '../2', progress: '1/2' } },
      { path: '2', component: Test2View },
    ],
  },
]

export default routes
